module.exports = __webpack_public_path__ + "static/media/vinceDang.c68aa3ac.jpg";